import { render, staticRenderFns } from "./DetailBarangHilang.vue?vue&type=template&id=4d3925b0&"
import script from "./DetailBarangHilang.vue?vue&type=script&lang=js&"
export * from "./DetailBarangHilang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports